import React, { SFC } from 'react'
import User from '../../../types/User'
import UserList from '../../../types/UserList'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Row, Col, Form } from 'react-bootstrap'
import Select from 'react-select'
import LightBlueSwitch from '../../LightBlueSwitch'
import './index.css'

type Props = {
	duplicateEmail: boolean
  emailError: boolean
  emailProvider: string
  firstNameProvider: string
  isLoggedUser: boolean
	lastNameProvider: string
	organizationOptions: any
  providerOptions: any
  roleOptions: any
	selectedEnabledData: boolean
	selectedOrganization: any
  selectedProvider: any
  selectedRole: any
  type: string
  user?: User | UserList
  viewOnly: boolean
  width:  number
	onChangeEnabledData: () => void
	onChangeOrganizationData: (selected: any) => void
  onChangeProviderData: (selected: any) => void
  onChangeProviderFields: (e:any, name:string) => void
  onChangeRoleData: (selected: any) => void
}

const UserData: SFC<Props> = (props) => {
  const { duplicateEmail, emailError, emailProvider, firstNameProvider, isLoggedUser, lastNameProvider, organizationOptions, providerOptions, roleOptions, selectedEnabledData, selectedOrganization, selectedProvider, selectedRole, type, user, viewOnly, width, onChangeEnabledData, onChangeOrganizationData, onChangeProviderData, onChangeProviderFields, onChangeRoleData } = props
  
  let errorMessage = (<div></div>)
  if(emailError)
		errorMessage = (
			<Form.Text className="provider-admin-error-msg">
				<FontAwesomeIcon icon={['fas', 'exclamation-circle']} className="login-error-icon"/> This field requires a valid email address.
			</Form.Text>
		)

	if(duplicateEmail)
		errorMessage = (
			<Form.Text className="provider-admin-error-msg">
				<FontAwesomeIcon icon={['fas', 'exclamation-circle']} className="login-error-icon"/> Email address already in use.
			</Form.Text>
		)

  let emailTxt = emailProvider
  if(user!==undefined){
		emailTxt = user.email!==undefined?user.email:emailProvider
	}

  return (
    <Row>
			<Form.Group as={Col} lg={6} md={6} sm={12} xs={12}>
				<Form.Label>First Name</Form.Label>
				<Form.Control placeholder="Enter a First name" value={firstNameProvider} disabled={viewOnly} onChange={(e: any)=>{onChangeProviderFields(e, 'firstName')}}/>
			</Form.Group>
			<Form.Group as={Col} lg={6} md={6} sm={12} xs={12}>
				<Form.Label>Last Name</Form.Label>
				<Form.Control placeholder="Enter a Last name" value={lastNameProvider} disabled={viewOnly} onChange={(e: any)=>{onChangeProviderFields(e, 'lastName')}}/>
			</Form.Group>
			<hr style={{width:width-120}}/>
			<Form.Group as={Col} lg={6} md={6} sm={12} xs={12}>
				<Form.Label>Email Address</Form.Label>
				<Form.Control placeholder="Enter a valid email address" value={emailTxt} onChange={(e: any)=>{onChangeProviderFields(e, 'email')}} isInvalid={emailError||duplicateEmail} disabled={viewOnly||type==='edit'}/>
				{errorMessage}
			</Form.Group>
			<hr style={{width:width-80}}/>
			<Form.Group as={Col} lg={6} md={6} sm={12} xs={12}>
				<Form.Label>User Role</Form.Label>
				<Select
					placeholder="Choose a User Role"
					options={roleOptions}
					value={roleOptions.find((role: any)=>role.label===selectedRole.label)}
					isDisabled={viewOnly||isLoggedUser}
					onChange={onChangeRoleData}
				/>
			</Form.Group>
			{selectedRole!==undefined?(
				selectedRole.value===4?(
					<Form.Group  as={Col} lg={6} md={6} sm={12} xs={12}>
						<Form.Label>Provider</Form.Label>
						<Select
							placeholder="Choose a Provider"
							options={providerOptions}
							value={selectedProvider}
							isDisabled={viewOnly}
							isMulti
							isClearable
							onChange={onChangeProviderData}
						/>
					</Form.Group>
				):(
					<Form.Group as={Col} lg={6} md={6} sm={12} xs={12}>
						<Form.Label>Organization</Form.Label>
						<Select
							placeholder="Choose an Organization"
							options={organizationOptions}
							value={selectedOrganization}
							isDisabled={viewOnly||selectedRole.value===4}
							isMulti
							isClearable
							onChange={onChangeOrganizationData}
						/>
					</Form.Group>
				)
			):(
				<div></div>
			)}
			<Form.Group as={Col} lg={6} md={6} sm={12} xs={12}>
				<Form.Label>Status</Form.Label>
				<Row>
					<Col>
					Disabled
					<LightBlueSwitch
						checked={selectedEnabledData===true}
						disabled={viewOnly||isLoggedUser}
						onChange={onChangeEnabledData}
					/>
					Enabled
					</Col>
				</Row>
	  	</Form.Group>
		</Row>
  )
}
export default UserData